export const zakupyData = {
    order: 0,
    name: 'zakupy',
    title: 'Zakupy',
    iconSrc: 'pic_zakupy.svg',
    headlineText:
        'Dowiedz się, jak możesz poprawić jakość swojego otoczenia, robiąc zakupy z głową!<br>Do dzieła!',
    mainText:
        'Kolekcje ubrań w sklepach nie zmieniają się raz w roku, a co 1-2 miesiące, więc aby nadążyć za modą, wciąż regularnie zmieniamy zawartość szafy. W sklepach AGD i RTV wciąż pojawiają się nowe modele telefonów i innego sprzętu elektronicznego, więc wymieniamy go na nowy, mimo że ten, który posiadamy, jest w pełni sprawny. Dzieje się tak właściwie ze wszystkim – kupujemy więcej i więcej. Niekoniecznie dlatego, że potrzebujemy aż tak dużo – <b>konsumpcjonizm</b> to zmora naszych czasów. Jak zmienić niekorzystne przyzwyczajenia? Oto kilka porad. ',
    mainVideoSrc:
        '<iframe width="560" height="315" src="https://www.youtube-nocookie.com/embed/7sD1UmFtHzo" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>',
    odpadySection: [
        {
            text:
                'Przed wyjściem do sklepu rób dokładną listę zakupów i staraj się jej trzymać. Kupuj tylko to, co potrzebujesz i nie dawaj się nabrać na sztuczki marketingowe.',
        },
        {
            text: '',
            picSrc: 'pics/pic-0.png',
            caption: '99% zakupionych przedmiotów wyrzucamy w ciągu 6 miesięcy!',
        },
        {
            text:
                'Zamiast tzw. jednorazówek, wykorzystuj torby wielokrotnego użytku (korzystaj np. z toreb bawełnianych).',
        },
        {
            text: 'Jeżeli masz możliwość, wybieraj produkty na wagę bez zbędnych opakowań i tacek.',
        },
        {
            text: '',
            picSrc: 'pics/pic-3.png',
            caption:
                'Ponad 40% odpadów trafia na składowisko, a więc nie może zostać poddana recyklingowi. W ten sposób tracimy cenne surowce i możliwość ponownego przetworzenia wielu materiałów.',
        },
        {
            text:
                'W przypadku ubrań czy sprzętu elektronicznego stawiaj na produkty dobrej jakości. Lepsza jakość to najczęściej dłuższa żywotność!',
        },
        {
            text: '',
            picSrc: 'pics/pic-1.png',
            caption: 'Marnujemy nawet 9 mln ton żywności rocznie!',
        },
        {
            text:
                'Unikaj tzw. fast fashion, czyli częstego kupowania i wyrzucania nietrwałej odzieży lub innych przedmiotów. Zastanów się nad „szafą kapsułową”, w której znajdują się tylko te ubrania, które lubisz i często nosisz.',
        },
        {
            text:
                'Spróbuj zakupów „z drugiej ręki”. Pozwala to nie tylko zaoszczędzić pieniądze, ale również zadbać o środowisko.',
        },
        {
            text: '',
            picSrc: 'pics/pic-2.png',
            caption: 'W ciągu miesiąca 4-osobowa rodzina wyrzuca jedzenie o wartości ok. 200 zł!',
        },
        {
            text:
                'Jeśli znudziły ci się Twoje rzeczy, skorzystaj ze stron, które umożliwiają ich wymianę lub sprzedaż.',
        },
    ],
    klimatSection: [
        {
            text:
                'Kupuj produkty lokalnych producentów – pozwala to między innymi ograniczyć koszty transportu wliczone w cenę produktu i zmniejsza Twój ślad węglowy. Lokalni producenci to często małe gospodarstwa i sklepy, które sprzedają produkty naturalne ze zrównoważonej hodowli, w której nie używa się pestycydów oraz innych substancji szkodliwych.',
        },
        {
            text:
                'Zwracaj uwagę na to, skąd pochodzą produkty, kto i w jaki sposób je wyprodukował, a także na rodzaj opakowania. ',
        },
        {
            text: 'Szukaj ekologicznych odpowiedników produktów codziennego użytku. ',
        },
    ],
    energiaSection: [],
    powietrzeSection: [
        {
            text:
                'Zakupy online często mogą być bardziej eko. Dowóz produktów spożywczych do wielu domów jedną ciężarówką zmniejsza liczbę samochodów na drodze, które znalazłyby się tam w celu dotarcia do sklepu.',
        },
    ],
    wodaSection: [],
    czyWieszSection: [
        {
            text: '...idąc na zakupy z pełnym brzuchem, kupisz mniej niepotrzebnych rzeczy?... ',
            more:
                'Amerykańska ekonomistka Alison Jing Xu udowodniła, że chęć posiadania rośnie, kiedy żołądek jest pusty i osoby kupujące „na głodniaka” wydają o 64% więcej – nie tylko na żywność, ale też odzież, elektronikę, a nawet produkty biurowe. Za to zjawisko odpowiada hormon o nazwie grelina wydzielany przez żołądek, gdy jesteśmy głodni, który wpływa na procesy związane z nagrodą i motywacją.',
        },
        {
            text: '...każdy z nas zostawia swój ślad węglowy?...',
            more:
                'Jest to całkowita suma emisji gazów cieplarnianych wywołanych bezpośrednio lub pośrednio przez daną osobę. Na jednego Polaka przypada średnio 10 ton gazów cieplarnianych emitowanych rocznie, z czego aż 8 ton to ilość CO2. Skąd tak duży ślad? Weźmy na przykład samochód – używając go, przyczyniamy się bezpośrednio do emisji gazów cieplarnianych poprzez spalanie paliwa (ślad zależy od rodzaju paliwa i przebytej odległości). Pośrednio zaś przyczyniliśmy się do emisji związanej z produkcją tego samochodu, wydobyciem paliwa oraz budową dróg.<br/><br/><a target="_blank" rel="noopener noreferrer" href="https://przekroj.pl/spoleczenstwo/gdzie-nie-spojrzec-widac-slad-weglowy-robert-rient">https://przekroj.pl/spoleczenstwo/gdzie-nie-spojrzec-widac-slad-weglowy-robert-rient</a>',
        },
        {
            text:
                '...rocznie produkuje się aż 2 miliony t-shirtów, a do produkcji jednej sztuki potrzeba 2,700 litrów wody?',
            more:
                '<div class="embed-wrapper"><iframe width="560" height="315" src="https://www.youtube-nocookie.com/embed/BiSYoeqb_VY" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>',
        },
    ],
};
